@if (projects?.length) { @if (projects | EntityFilter: filterModels | async; as filteredProjects) {
<app-status-filter
  [filterTabsCount]="filteredProjects | StatusFilterCount"
  [filterTabs]="['all', 'new', 'in progress', 'completed']"
></app-status-filter>
<app-separator></app-separator>
<app-project-filter
  [projects]="projects | ProjectVMToProject | async"
  [filters]="filterModels"
  [displaySearchField]="myProjects"
  (showGridview)="toggleGridview($event)"
></app-project-filter>
@if (showGridview) {
<div class="project-grid-container">
  <ng-container *ngFor="let project of filteredProjects | EntityFilter : nonSelectFilters | async as projects">
    <app-project-card [project]="project"></app-project-card>
  </ng-container>
</div>
} @if (!showGridview) {
<mat-table
  class="table"
  [dataSource]="filteredProjects | EntityFilter : nonSelectFilters | async | ArrayToDatasource : sort"
  matSort
  (matSortChange)="sort = $event"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
    <mat-cell *matCellDef="let project">
      <a class="project-link" [routerLink]="['/project', project.id]">{{ project.name }}</a>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
    <mat-cell *matCellDef="let project">
      <app-status-badge [status]="project.status"> </app-status-badge>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="businessUnit">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Business Unit</mat-header-cell>
    <mat-cell *matCellDef="let project">
      {{ project.businessUnit }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="region">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Region</mat-header-cell>
    <mat-cell *matCellDef="let project">
      {{ project.region }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="country">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
    <mat-cell *matCellDef="let project">
      {{ project.country }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="location">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
    <mat-cell *matCellDef="let project">
      {{ project.location }}
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row class="project-row" *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
} } }
